import {useTranslation} from "react-i18next";
import {Divider, Grid, Stack, Textarea, TextInput} from "@mantine/core";
import {useNoticeFormContext} from "./useNoticeForm";
import {NoticeCategorySelect} from "../../select/entity/NoticeCategorySelect/NoticeCategorySelect";
import {NoticeKindSelect} from "../../select/entity/NoticeKindSelect/NoticeKindSelect";
import {NoticeSeveritySelect} from "../../select/entity/NoticeSeveritySelect/NoticeSeveritySelect";
import {NoticeFormProps} from "./NoticeForm";
import {RegionMultiSelect} from "../../select/entity/RegionSelect/RegionMultiSelect";
import {emptyOrUndefined} from "@ots-frontend/ots-data";
import {CompanyMultiSelect} from "../../select/entity/CompanySelect/CompanyMultiSelect";
import {
  PersonCapabilityTypeMultiSelect
} from "../../select/entity/PersonCapabilityTypeSelect/PersonCapabilityTypeMultiSelect";
import { DateInput } from "../../date/DateInput/DateInput";

export type NoticeFormFieldProps = Pick<NoticeFormProps, 'options'> & {}

export const NoticeFormFields = (props: NoticeFormFieldProps) => {
  const {
    options,
  } = props;

  const {t} = useTranslation(["common"]);

  const form = useNoticeFormContext();

  return (
    <Stack spacing="xs">
      <Grid>
        <Grid.Col span={4}>
          <NoticeKindSelect
            size="xs"
            label={t("common.entity.notice.form.field.kind", "Kind")}
            placeholder={t<string>("common.entity.notice.form.field.kind.placeholder", "Kind")}
            withAsterisk
            required
            clearable
            {...form.getInputProps("kind")} />
        </Grid.Col>
        <Grid.Col span={4}>
          <NoticeCategorySelect
            size="xs"
            label={t("common.entity.notice.form.field.category", "Category")}
            placeholder={t<string>("common.entity.notice.form.field.category.placeholder", "Category")}
            withAsterisk
            required
            clearable
            {...form.getInputProps("category")} />
        </Grid.Col>
        <Grid.Col span={4}>
          <NoticeSeveritySelect
            size="xs"
            label={t("common.entity.notice.form.field.severity", "Severity")}
            placeholder={t<string>("common.entity.notice.form.field.severity.placeholder", "Severity")}
            withAsterisk
            required
            clearable
            {...form.getInputProps("severity")} />
        </Grid.Col>
      </Grid>

      <Divider label="Message" labelPosition="left" variant="dotted" mt="md" mb="sm"/>

      <TextInput
        size="xs"
        label={t("common.entity.notice.form.field.title", "Title")}
        placeholder={t<string>("common.entity.notice.form.field.title.placeholder", "Road 897 Closed for Maintenance")}
        withAsterisk
        required
        {...form.getInputProps('title')}/>

      <Textarea
        size="xs"
        label={t("common.entity.notice.form.field.message", "Message")}
        placeholder={t<string>("common.entity.notice.form.field.message.placeholder", "Road 897 closed by 10am")}
        minRows={4}
        autosize
        withAsterisk
        required
        {...form.getInputProps('bodyText')} />

      <Divider label="Expiration" labelPosition="left" variant="dotted" mt="md" mb="sm"/>

      <DateInput
        size="xs"
        label={t("common.entity.notice.form.field.expiration", "Expiration")}
        valueFormat="MM/DD/YYYY HH:mm"
        clearable
        {...form.getInputProps('expiresDate')}/>

      <Divider label="Scope" labelPosition="left" variant="dotted" mt="md" mb="sm"/>

      <RegionMultiSelect
        size="xs"
        label={t("common.entity.notice.form.field.regions", "Regions")}
        placeholder={emptyOrUndefined(form.values.regions) ? t<string>("common.entity.notice.form.field.regions.placeholder.empty", "Global (no region restrictions)") : t<string>("common.entity.notice.form.field.regions.placeholder", "Regions")}
        selector={{
          regionId: options?.regionId,
        }}
        searchable
        clearable
        {...form.getInputProps('regions')} />

      <CompanyMultiSelect
        size="xs"
        label={t("common.entity.notice.form.field.companies", "Companies")}
        placeholder={emptyOrUndefined(form.values.companies) ? t<string>("common.entity.notice.form.field.regions.placeholder.empty", "Global (no company restrictions)") : t<string>("common.entity.notice.form.field.companies.placeholder", "Companies")}
        selector={{
          regionId: options?.regionId,
        }}
        searchable
        clearable
        {...form.getInputProps('companies')} />

      <PersonCapabilityTypeMultiSelect
        size="xs"
        label={t("common.entity.notice.form.field.audience", "Audience")}
        placeholder={emptyOrUndefined(form.values.audienceCapabilities) ? t<string>("common.entity.notice.form.field.audience.placeholder.empty", "Global (no audience restrictions)") : t<string>("common.entity.notice.form.field.audience.placeholder", "Audience")}
        searchable
        clearable
        {...form.getInputProps('audienceCapabilities')} />
    </Stack>
  )
}
